import React, { useCallback, useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { useAnimationContext } from '../../../context/AnimationContext';
import { useNavigationContext } from '../../../context/NavigationContext';
import { useAudioContext } from '../../../context/AudioContext';
import { SectionIDs } from '../../../data/Sections';
import BasePageProps from '../../view2D/BasePageProps';
import BaseSection from '../../view2D/BaseSection';
import Button from '../../../elements/Button';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

const masterStyle: React.CSSProperties = {
  opacity: '1'
};

interface ITellMeAJoke {
  video?: HTMLVideoElement
}

function TellMeAJoke({ ...props }: BasePageProps & ITellMeAJoke): JSX.Element {
  const { playAudio } = useAudioContext();
  const { activeSectionID, moveToTheSection } = useNavigationContext();
  const { AddAnimations } = useAnimationContext();

  const {t} = useTranslation('ai4Jokes');

  const titleTextRef1 = useRef<HTMLDivElement>(null);
  const titleTextRef2 = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if(activeSectionID === SectionIDs.TellMeAJoke){
      gsap.fromTo(titleTextRef1.current, { bottom: '-4rem' }, { bottom: '0rem', duration: 0.3, delay: 0.4});
      gsap.fromTo(titleTextRef2.current, { bottom: '-2rem' }, { bottom: '2.5rem', duration: 0.3, delay: 0.8});
      gsap.fromTo(buttonRef.current, { opacity: '0' }, { opacity: '1', duration: 0.3, delay: 1.1});
    }
  },
  [activeSectionID]);

  useEffect(() => {
    AddAnimations([
      {
        targets: masterStyle,
        from: { opacity: '1' },
        to: { opacity: '0' },
        start: 0.9,
        end: 1
      },
    ], props.sectionID);
  }, [ AddAnimations, props.sectionID ]);

  const goToTheJoke = useCallback(() => {
    playAudio('audioCTA');
    moveToTheSection(SectionIDs.Joke);

    props.video?.play();
  }, [playAudio, moveToTheSection, props.video]);


  return (
    <BaseSection {...props} style={{position: 'fixed', height: '100%' }}>
      <div className={styles.container} style={{...masterStyle}}>
        <div className={styles.innerContainer}>
          <section>
            <div className={styles.upperTitle}>
              <div ref={titleTextRef1}>
                {t('tellmeajoke.subtitle')}
              </div>
            </div>
            <div className={styles.title}>
              <h2 ref={titleTextRef2}>
                {t('tellmeajoke.title')}
              </h2>
            </div>
            <Button
              className={styles.button}
              buttonRef={buttonRef} 
              style={{opacity: '0'}} 
              click={goToTheJoke}>
              {t('tellmeajoke.button')}
            </Button>
          </section>
        </div>
      </div>
    </BaseSection>
  );
}

export default React.memo(TellMeAJoke);